const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary-green text-white px-4 py-2 rounded-lg z-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
    >
      Skip to main content
    </a>
  )
}

export default SkipToContent